import { render, staticRenderFns } from "./IdCardField.vue?vue&type=template&id=399cdca5&"
import script from "./IdCardField.vue?vue&type=script&lang=js&"
export * from "./IdCardField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports